import { useMutation, UseMutationResult } from 'react-query';
import { fetchDownloadDealReport } from '../../services/dealReport/dealReport.service';
import { ApiError } from '../../services/api-error.model';

export default (): UseMutationResult<Blob, ApiError, number | null, void> => {
  return useMutation(async (reportId: number | null) => fetchDownloadDealReport(reportId));
};
